import { put, select } from 'redux-saga/effects';
import type { SagaIterator } from 'redux-saga';
import { selectors, withOffset } from '../../Stream';
import {
  GALLECTIONS_PER_FETCH,
  MEDIA_POPUP_GALLECTION_STREAM_GROUP,
} from '../constants';
import { getGallectionStreamId } from '../helpers';
import { getMode, getCurrentMediaSource } from '../selectors';
import {
  GallectionStreamParams,
  MediaPopupMode,
  MediaSourceType,
} from '../types';
import { initGallectionStream } from '../actions';

export function getStreamInitAction(
  mediaSource?: MediaSourceType,
  folderId?: number
) {
  const streamId = getGallectionStreamId(mediaSource, folderId);
  const streamParams: GallectionStreamParams = { mediaSource, folderId };

  return withOffset.actions.initialize({
    streamId,
    groupId: MEDIA_POPUP_GALLECTION_STREAM_GROUP,
    streamParams,
    itemsPerFetch: GALLECTIONS_PER_FETCH,
    hasMore: true,
  });
}

function* handleInitGallectionStream(
  action: ReturnType<typeof initGallectionStream>
): SagaIterator {
  const mediaSource: ReturnType<typeof getCurrentMediaSource> = yield select(
    getCurrentMediaSource
  );
  if (!mediaSource) {
    return;
  }

  const mode: ReturnType<typeof getMode> = yield select(getMode);
  const folderId = action.payload.folderId;

  const streamId = getGallectionStreamId(mediaSource, folderId);
  const isStreamInitialized: ReturnType<typeof selectors.isInitialized> =
    yield select(selectors.isInitialized, streamId);

  let cacheStreams = true;
  if (mode === MediaPopupMode.MANAGER) {
    cacheStreams = false;
  }

  if (isStreamInitialized && cacheStreams) {
    return;
  }

  yield put(getStreamInitAction(mediaSource, folderId));
  yield put(withOffset.actions.fetch(streamId));
}

export default handleInitGallectionStream;
